// NPM Imports
import React, { useState, useEffect } from "react";

// Component imports
import { DocumentErrorRecipient404 } from "../../components/ErrorComponents";

// Internal Imports
import { IMAGE_URLS } from "../../constants";

// Destructure
const { OH_SNAP } = IMAGE_URLS;

export default function ErrorBoundaryFallback() {
  const [errRecipient404, setErrRecipient404] = useState(false);
  const { pathname } = window.location;

  useEffect(() => {
    if (pathname.split("/").includes("signing-documents")) {
      setErrRecipient404(true);
    }
  }, []);

  if (errRecipient404) {
    return <DocumentErrorRecipient404 isError />;
  }
  return (
    <div className="errorboundaryfallback-wrapper">
      <img
        className="errorboundaryfallback-img"
        src={OH_SNAP}
        alt="oh-snap-img"
      />
      <p className="errorboundaryfallback-title">
        Oh Snap! Something went wrong
      </p>
      <p className="errorboundaryfallback-sub-title">
        Our best minds are on it, If you see this again, ping us on chat.
      </p>

      <p className="errorboundaryfallback-redirect ">
        <a href="/assets" data-test="errorboundaryfallback-redirect">
          Go to the Documents page
        </a>{" "}
        in your Revv account and you can navigate from there.
      </p>
    </div>
  );
}
